var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeDuration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.32776 2.0602C2.83303 2.0602 0 4.89323 0 8.38796C0 11.8827 2.83303 14.7157 6.32776 14.7157C9.82248 14.7157 12.6555 11.8827 12.6555 8.38796C12.6515 4.89491 9.8208 2.06425 6.32776 2.0602L6.32776 2.0602ZM9.02809 11.2796C8.88861 11.4384 8.68759 11.5295 8.47625 11.5298C8.29487 11.5313 8.11931 11.4658 7.98327 11.3458L5.84214 9.44749C5.68337 9.30801 5.59224 9.10699 5.59197 8.89565V5.21672C5.59197 4.81036 5.92139 4.48093 6.32776 4.48093C6.73412 4.48093 7.06354 4.81036 7.06354 5.21672V8.53511L8.96187 10.2127C9.11708 10.3423 9.21211 10.5301 9.22464 10.7319C9.23716 10.9337 9.16608 11.1318 9.02809 11.2796H9.02809ZM4.46622 0.934448L8.53511 1.47157H4.1204C3.71404 1.47157 3.38461 1.14215 3.38461 0.735786C3.38461 0.329423 3.71404 0 4.1204 0H8.53511C8.94148 0 9.2709 0.329423 9.2709 0.735786C9.2709 1.14215 8.94148 1.47157 8.53511 1.47157L4.46622 0.934448Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeDuration);
export default __webpack_public_path__ + "static/media/time_duration.526bc252a500c8a49833fafe449084c7.svg";
export { ForwardRef as ReactComponent };